function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("metadata", {
  id: "metadata2"
});

var _ref3 =
/*#__PURE__*/
React.createElement("defs", {
  id: "defs7"
}, React.createElement("clipPath", {
  id: "clipEmfPath1"
}, React.createElement("path", {
  d: "m0.32013 0.48019h41.937v41.777h-41.937z",
  id: "path4"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m0.63891 20.07c0-10.727 8.7061-19.433 19.433-19.433 10.747 0 19.433 8.7061 19.433 19.433 0 10.747-8.6866 19.433-19.433 19.433-10.727 0-19.433-8.6866-19.433-19.433z",
  fill: "#fff",
  fillRule: "evenodd",
  id: "path9"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  id: "path16",
  fillRule: "evenodd",
  fill: "#ffffff",
  d: "m 9.5054801,8.7403194 c 0,-1.8772 1.5393009,-3.4165 3.4165009,-3.4165 h 16.031 c 1.8772,0 3.379,1.5393 3.379,3.4165 V 22.368314 c 0,1.8772 -1.5018,3.379 -3.379,3.379 h -16.031 c -1.8772,0 -3.4165009,-1.5018 -3.4165009,-3.379 z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  id: "path18",
  strokeWidth: "0.6007px",
  strokeMiterlimit: 10,
  strokeLinejoin: "round",
  strokeLinecap: "round",
  stroke: "#002060",
  fill: "none",
  d: "m 9.5054801,8.7403194 c 0,-1.8772 1.5393009,-3.4165 3.4165009,-3.4165 h 16.031 c 1.8772,0 3.379,1.5393 3.379,3.4165 V 22.368314 c 0,1.8772 -1.5018,3.379 -3.379,3.379 h -16.031 c -1.8772,0 -3.4165009,-1.5018 -3.4165009,-3.379 z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  id: "path20",
  fillRule: "evenodd",
  fill: "#ecaec6",
  d: "m 12.921781,5.3241194 h 15.994 c 1.9147,0 3.4165,1.5393 3.4165,3.4541 V 12.682814 H 9.5052801 V 8.7782194 c 0,-1.9147 1.5393009,-3.4541 3.4165009,-3.4541 z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  id: "path22",
  strokeWidth: "0.6007px",
  strokeMiterlimit: 10,
  strokeLinejoin: "round",
  strokeLinecap: "round",
  stroke: "#002060",
  fill: "none",
  d: "m 12.921781,5.3241194 h 15.994 c 1.9147,0 3.4165,1.5393 3.4165,3.4541 V 12.682814 H 9.5052801 V 8.7782194 c 0,-1.9147 1.5393009,-3.4541 3.4165009,-3.4541 z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  id: "path24",
  fillRule: "evenodd",
  fill: "#adb9ca",
  d: "m 13.710781,8.2903194 c 0,-0.22526 0.18772,-0.41298 0.41298,-0.41298 h 13.929 c 0.22526,0 0.37544,0.18772 0.37544,0.41298 v 1.6143952 c 0,0.2252594 -0.15018,0.3754394 -0.37544,0.3754394 h -13.929 c -0.22526,0 -0.41298,-0.15018 -0.41298,-0.3754394 z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  id: "path26",
  strokeWidth: "0.6007px",
  strokeMiterlimit: 10,
  strokeLinejoin: "round",
  strokeLinecap: "round",
  stroke: "#002060",
  fill: "none",
  d: "m 13.710781,8.2903194 c 0,-0.22526 0.18772,-0.41298 0.41298,-0.41298 h 13.929 c 0.22526,0 0.37544,0.18772 0.37544,0.41298 v 1.6143952 c 0,0.2252594 -0.15018,0.3754394 -0.37544,0.3754394 h -13.929 c -0.22526,0 -0.41298,-0.15018 -0.41298,-0.3754394 z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  id: "path28",
  fillRule: "evenodd",
  fill: "#adb9ca",
  d: "m 14.160781,15.235314 v 3.0035 h 2.8533 v -3.0035 z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  id: "path30",
  strokeWidth: "0.6007px",
  strokeMiterlimit: 10,
  strokeLinejoin: "round",
  strokeLinecap: "round",
  stroke: "#002060",
  fill: "none",
  d: "m 14.160781,15.235314 h 2.8533 v 3.0035 h -2.8533 z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  id: "path32",
  strokeWidth: "0.6007px",
  strokeMiterlimit: 8,
  stroke: "#002060",
  fill: "none",
  d: "m 20.167781,16.737314 h 7.9593"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  id: "path34",
  fillRule: "evenodd",
  fill: "#adb9ca",
  d: "m 14.160781,20.492314 v 3.0035 h 2.8533 v -3.0035 z"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  id: "path36",
  strokeWidth: "0.6007px",
  strokeMiterlimit: 10,
  strokeLinejoin: "round",
  strokeLinecap: "round",
  stroke: "#002060",
  fill: "none",
  d: "m 14.160781,20.492314 h 2.8533 v 3.0035 h -2.8533 z"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  id: "path38",
  strokeWidth: "0.6007px",
  strokeMiterlimit: 8,
  stroke: "#002060",
  fill: "none",
  d: "m 20.167781,21.993314 h 7.9593"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  id: "path48",
  fillRule: "evenodd",
  fill: "#ffffff",
  d: "m 9.5054801,8.7403194 c 0,-1.8772 1.5393009,-3.4165 3.4165009,-3.4165 h 16.031 c 1.8772,0 3.379,1.5393 3.379,3.4165 V 22.368314 c 0,1.8772 -1.5036,3.2952 -3.379,3.379 l -16.097,0.71875 c -1.8753,0.08374 -3.3512009,-2.2205 -3.3512009,-4.0977 z"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  id: "path50",
  fillRule: "evenodd",
  fill: "#ecaec6",
  d: "m 12.921781,5.3241194 h 15.994 c 1.9147,0 3.4165,1.5393 3.4165,3.4541 V 12.682814 H 9.5052801 V 8.7782194 c 0,-1.9147 1.5393009,-3.4541 3.4165009,-3.4541 z",
  className: "icon-primary"
});

var _ref19 =
/*#__PURE__*/
React.createElement("g", {
  id: "g58",
  fillRule: "evenodd",
  fill: "#adb9ca",
  transform: "translate(2.8437801,-2.8826806)"
}, React.createElement("path", {
  id: "path52",
  d: "m 10.867,11.173 c 0,-0.22526 0.18272,-0.41298 0.40198,-0.41298 h 13.558 c 0.21926,0 0.36544,0.18772 0.36544,0.41298 v 1.6144 c 0,0.22526 -0.14618,0.37544 -0.36544,0.37544 h -13.558 c -0.21926,0 -0.40198,-0.15018 -0.40198,-0.37544 z",
  className: "icon-secondary"
}), React.createElement("path", {
  id: "path54",
  d: "m 11.317,18.707 v 1.6967 h 2.2653 V 18.707 Z",
  className: "icon-secondary"
}), React.createElement("path", {
  id: "path56",
  d: "m 11.448,23.505 v 1.9581 h 2.0039 V 23.505 Z",
  className: "icon-secondary"
}));

var _ref20 =
/*#__PURE__*/
React.createElement("g", {
  id: "g78",
  stroke: "#002060",
  fill: "none",
  className: "icon-tertiary",
  transform: "translate(2.8437801,-2.8826806)"
}, React.createElement("g", {
  id: "g68",
  strokeLinejoin: "round",
  strokeLinecap: "round"
}, React.createElement("path", {
  id: "path60",
  strokeMiterlimit: 9.3333,
  d: "m 6.6015,12.193 c 0,-1.9003 1.5518,-3.4585 3.4443,-3.4585 h 16.162 c 1.8925,0 3.4065,1.5582 3.4065,3.4585 v 13.796 c 0,1.9003 -1.514,3.4205 -3.4065,3.4205 h -16.162 c -1.8925,0 -3.4443,-1.5202 -3.4443,-3.4205 z"
}), React.createElement("path", {
  id: "path62",
  strokeWidth: 0.97942,
  strokeMiterlimit: 9.3333,
  d: "m 10.071,8.4579 h 16.008 c 1.9165,0 3.4196,1.4753 3.4196,3.3104 v 3.7421 H 6.6516 v -3.7421 c 0,-1.8351 1.5407,-3.3104 3.4196,-3.3104 z"
}), React.createElement("path", {
  id: "path64",
  strokeMiterlimit: 10,
  d: "m 10.468,10.997 c 0,-0.27542 0.19204,-0.50494 0.4225,-0.50494 h 14.25 c 0.23045,0 0.38409,0.22952 0.38409,0.50494 v 1.9739 c 0,0.27542 -0.15364,0.45904 -0.38409,0.45904 h -14.25 c -0.23045,0 -0.4225,-0.18361 -0.4225,-0.45904 z"
}), React.createElement("path", {
  id: "path66",
  strokeMiterlimit: 9,
  d: "m 11.491,18.488 h 2.048 v 2.0675 h -2.048 z"
})), React.createElement("g", {
  id: "g76",
  strokeMiterlimit: 9
}, React.createElement("path", {
  id: "path70",
  strokeWidth: 1.052,
  d: "m 17.128,19.49 h 8.8088"
}), React.createElement("path", {
  id: "path72",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  d: "m 11.601,23.543 h 1.8645 v 1.9626 H 11.601 Z"
}), React.createElement("path", {
  id: "path74",
  strokeWidth: 1.0559,
  d: "m 16.998,24.55 h 8.8741"
})));

var SvgReportSurvey = function SvgReportSurvey(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    id: "svg51",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, React.createElement("path", {
    className: "icon-tertiary",
    transform: "matrix(.97127 0 0 .97127 -.52709 -.52879)",
    d: "m1.2005 21.208c0-11.044 8.9636-20.008 20.008-20.008 11.064 0 20.008 8.9636 20.008 20.008 0 11.064-8.9436 20.008-20.008 20.008-11.044 0-20.008-8.9436-20.008-20.008",
    clipPath: "url(#clipEmfPath1)",
    fill: "none",
    stroke: "#002060",
    strokeMiterlimit: 8,
    id: "path11",
    style: {
      strokeWidth: 0.99972201,
      strokeMiterlimit: 8,
      strokeDasharray: "none"
    }
  }), _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, React.createElement("path", {
    id: "path13-3-0",
    fillRule: "evenodd",
    fill: "#adb9ca",
    d: "m 22.212442,22.744189 0.078,0.108916 c 0.733108,0.746889 1.746974,1.198171 2.870042,1.198171 1.138639,0 2.152532,-0.451238 2.885613,-1.198171 l 0.078,-0.108916 0.592729,0.124473 c 1.731403,0.731323 2.932415,2.442897 2.932415,4.419 v 4.030034 l -2.090159,0.762437 c -1.435021,0.326765 -2.901272,0.497917 -4.398667,0.497917 -1.481822,0 -2.948074,-0.171161 -4.383007,-0.497917 l -2.10573,-0.762437 v -4.030034 c 0,-1.976103 1.216671,-3.687712 2.948074,-4.419 z",
    className: "icon-secondary",
    style: {
      strokeWidth: 1.13755
    }
  }), React.createElement("path", {
    id: "path15-0-3",
    strokeMiterlimit: 8,
    stroke: "#002060",
    fill: "none",
    d: "m 22.212442,22.744189 0.078,0.108916 c 0.733108,0.746889 1.746974,1.198171 2.870042,1.198171 1.138639,0 2.152532,-0.451238 2.885613,-1.198171 l 0.078,-0.108916 0.592729,0.124473 c 1.731403,0.731323 2.932415,2.442897 2.932415,4.419 v 4.030034 l -2.090159,0.762437 c -1.435021,0.326765 -2.901272,0.497917 -4.398667,0.497917 -1.481822,0 -2.948074,-0.171161 -4.383007,-0.497917 l -2.10573,-0.762437 v -4.030034 c 0,-1.976103 1.216671,-3.687712 2.948074,-4.419 z",
    className: "icon-tertiary",
    style: {
      strokeWidth: 1.13755
    }
  }), React.createElement("path", {
    id: "path17-2-3",
    fillRule: "evenodd",
    fill: "#adb9ca",
    d: "m 21.167319,20.440962 c 0,-2.225136 1.793777,-4.045582 3.99311,-4.045582 2.214905,0 3.99311,1.820534 3.99311,4.045582 0,2.240684 -1.778205,4.045581 -3.99311,4.045581 -2.199333,0 -3.99311,-1.804985 -3.99311,-4.045581 z",
    className: "icon-secondary",
    style: {
      strokeWidth: 1.13755
    }
  }), React.createElement("path", {
    style: {
      strokeWidth: 1.13755
    },
    className: "icon-tertiary",
    d: "m 21.166973,20.44061 c 0,-2.225136 1.793776,-4.045582 3.993109,-4.045582 2.214905,0 3.99311,1.820534 3.99311,4.045582 0,2.240684 -1.778205,4.045582 -3.99311,4.045582 -2.199333,0 -3.993109,-1.804986 -3.993109,-4.045582",
    fill: "none",
    stroke: "#002060",
    strokeMiterlimit: 8,
    id: "path21-8-4"
  }), React.createElement("path", {
    style: {
      strokeWidth: 1.13755
    },
    className: "icon-secondary",
    d: "m 9.7025513,22.743838 0.07799,0.108916 c 0.7175107,0.746889 1.7314027,1.19817 2.8388117,1.19817 1.123067,0 2.121301,-0.451238 2.854471,-1.19817 l 0.07799,-0.108916 0.592729,0.124473 c 1.715832,0.731323 2.901273,2.442897 2.901273,4.419 v 4.030033 l -2.074499,0.762437 c -1.403791,0.326765 -2.870043,0.497917 -4.351866,0.497917 -1.466163,0 -2.9324145,-0.171161 -4.3362051,-0.497917 L 6.1930854,31.317344 v -4.030033 c 0,-1.976103 1.2011,-3.687712 2.9168441,-4.419 z",
    fill: "#adb9ca",
    fillRule: "evenodd",
    id: "path23-4-1"
  }), React.createElement("path", {
    style: {
      strokeWidth: 1.13755
    },
    className: "icon-tertiary",
    d: "m 9.7025513,22.743838 0.07799,0.108916 c 0.7175107,0.746889 1.7314027,1.19817 2.8388117,1.19817 1.123067,0 2.121301,-0.451238 2.854471,-1.19817 l 0.07799,-0.108916 0.592729,0.124473 c 1.715832,0.731323 2.901273,2.442897 2.901273,4.419 v 4.030033 l -2.074499,0.762437 c -1.403791,0.326765 -2.870043,0.497917 -4.351866,0.497917 -1.466163,0 -2.9324145,-0.171161 -4.3362051,-0.497917 L 6.1930854,31.317344 v -4.030033 c 0,-1.976103 1.2011,-3.687712 2.9168441,-4.419 z",
    fill: "none",
    stroke: "#002060",
    strokeMiterlimit: 8,
    id: "path25-5-4"
  }), React.createElement("path", {
    style: {
      strokeWidth: 1.13755
    },
    className: "icon-secondary",
    d: "m 8.5639124,20.44061 c 0,-2.225136 1.8250066,-4.045582 4.0554826,-4.045582 2.246135,0 4.055483,1.820534 4.055483,4.045582 0,2.240684 -1.809436,4.045582 -4.055483,4.045582 -2.230564,0 -4.0554826,-1.804986 -4.0554826,-4.045582 z",
    fill: "#adb9ca",
    fillRule: "evenodd",
    id: "path27-1-3"
  }), React.createElement("path", {
    style: {
      strokeWidth: 1.13755
    },
    className: "icon-tertiary",
    d: "m 8.5639124,20.44061 c 0,-2.225136 1.8250066,-4.045582 4.0554826,-4.045582 2.246135,0 4.055483,1.820534 4.055483,4.045582 0,2.240684 -1.809436,4.045582 -4.055483,4.045582 -2.230564,0 -4.0554826,-1.804986 -4.0554826,-4.045582",
    fill: "none",
    stroke: "#002060",
    strokeMiterlimit: 8,
    id: "path29-2-8"
  }), React.createElement("path", {
    style: {
      strokeWidth: 1.13755
    },
    className: "icon-primary",
    d: "m 15.775966,24.859961 0.078,0.124473 c 0.795499,0.793568 1.90304,1.291547 3.119535,1.291547 1.232243,0 2.339739,-0.497917 3.135194,-1.291547 l 0.078,-0.124473 L 22.841815,25 c 1.871809,0.793559 3.181996,2.645198 3.181996,4.808054 v 4.372355 l -2.277278,0.840248 c -1.544196,0.357879 -3.150765,0.544596 -4.772994,0.544596 -1.606569,0 -3.213138,-0.186717 -4.757422,-0.544596 l -2.292943,-0.840248 v -4.372355 c 0,-2.162856 1.325846,-4.014486 3.197567,-4.808054 z",
    fill: "#ecaec6",
    fillRule: "evenodd",
    id: "path31-4-3"
  }), React.createElement("path", {
    style: {
      strokeWidth: 1.13755
    },
    className: "icon-tertiary",
    d: "m 15.775966,24.859961 0.078,0.124473 c 0.795499,0.793568 1.90304,1.291547 3.119535,1.291547 1.232243,0 2.339739,-0.497917 3.135194,-1.291547 l 0.078,-0.124473 L 22.841815,25 c 1.871809,0.793559 3.181996,2.645198 3.181996,4.808054 v 4.372355 l -2.277278,0.840248 c -1.544196,0.357879 -3.150765,0.544596 -4.772994,0.544596 -1.606569,0 -3.213138,-0.186717 -4.757422,-0.544596 l -2.292943,-0.840248 v -4.372355 c 0,-2.162856 1.325846,-4.014486 3.197567,-4.808054 z",
    fill: "none",
    stroke: "#002060",
    strokeMiterlimit: 8,
    id: "path33-6-4"
  }), React.createElement("path", {
    style: {
      strokeWidth: 1.13755
    },
    className: "icon-primary",
    d: "m 14.54434,22.245772 c 0,-2.396253 1.996554,-4.356808 4.429809,-4.356808 2.448914,0 4.42981,1.960555 4.42981,4.356808 0,2.411801 -1.980896,4.356807 -4.42981,4.356807 -2.433343,0 -4.429809,-1.945006 -4.429809,-4.356807 z",
    fill: "#ecaec6",
    fillRule: "evenodd",
    id: "path35-8-4"
  }), React.createElement("path", {
    className: "icon-tertiary",
    style: {
      strokeWidth: 1.13755
    },
    d: "m 14.54434,22.245772 c 0,-2.396253 1.996554,-4.356808 4.429809,-4.356808 2.448914,0 4.42981,1.960555 4.42981,4.356808 0,2.411801 -1.980896,4.356807 -4.42981,4.356807 -2.433343,0 -4.429809,-1.945006 -4.429809,-4.356807",
    fill: "none",
    stroke: "#002060",
    strokeMiterlimit: 8,
    id: "path37-5-1"
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgReportSurvey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/report-survey.633591bb.svg";
export { ForwardRef as ReactComponent };